import {useParams} from 'react-router-dom';

import {Alert, Stack} from '@mantine/core';
import {I18n} from '@aws-amplify/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';

import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useProductLineItem} from '../hooks/useProductLineItem.ts';
import {ProductLineItem} from '../types.ts';

import {useEditPageTools} from '../hooks/useEditPageTools';
import {moduleConfig} from '../config';


export const EditPage = () => {

    const {
        id: productId,
        productLineItemId
    } = useParams();

    if (typeof productId === 'undefined') {
        throw new Error('productId is required parameter');
    }

    // The detail query loads on mount by itself (enabled on the id); the page needs
    // nothing from the list.
    const {
        record,
        isError,
        updateRecord,
    } = useProductLineItem(productId, productLineItemId);

    const {
        mode,
        tools,
    } = useEditPageTools(productId);

    if (isError) {
        return (
            <Alert color='red' title={I18n.get('Could not load the product line item')} m='md'>
                {I18n.get('The billing API did not return this line item. It may have been deleted.')}
            </Alert>
        );
    }

    if (!record) {
        return <PlatformLoader message={I18n.get('Loading product line item...Please wait')}/>;
    }


    return (
        <FormPageLayout
            title={`${I18n.get(moduleConfig.titles.singular)}: ${record.productFeature?.name ?? record.productFeatureId}`}
            pageNavigation={<EditPageNavigation component={record}/>}
            tools={tools}
        >


            {mode === 'view' ?
                <Stack gap='lg'>
                    <Profile
                        record={record}
                    />
                </Stack>
                :
                <RecordForm
                    record={record as Omit<ProductLineItem, 'id'>}
                    handleSubmit={updateRecord}
                />}


        </FormPageLayout>
    );
};
